import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import WithError from '../../../../../components/with-error/WithError';
import CommonTextarea from '../../../../../components/common-textarea/CommonTextarea';
import { BUTTON_STYLES } from '../../../../../components/common-button/CommonButton';
import { SCOUT_TABS } from '../../../../../constants';
import TooltipButton from '../../../../../components/tooltip-button/TooltipButton';
import { ICONS } from '../../../../../icons';
import Icon from '../../../../../icons/Icon';

import scss from './RepliesForm.module.scss';

function RepliesFormInner({ onSubmit, disabled }) {
  const { t } = useTranslation('scout');

  const { input: hintInput } = useField('hint');

  const isFormLoading = useSelector((state) => state.scout.isFormLoading);
  const isGenerating = useSelector((state) => state.scout.isGenerating);
  const isResetting = useSelector((state) => state.scout.isResetting);
  const scoutTab = useSelector((state) => state.scout.scoutTab);

  const isDisabled =
    disabled ||
    isFormLoading ||
    isResetting ||
    scoutTab === SCOUT_TABS.FINAL_MESSAGES ||
    scoutTab === SCOUT_TABS.SCREENED_MESSAGES ||
    scoutTab === SCOUT_TABS.BACKUP ||
    isGenerating;

  return (
    <div className={scss.repliesForm}>
      <Field name='hint'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('hints')} isBold extraClassName={scss.hintsField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                isReadOnly
                rows='2'
                resize='none'
                isError={meta.touched && meta.error}
                disabled={isDisabled || !hintInput.value}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='reply'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('replies')} isBold extraClassName={scss.hintsField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                rows='2'
                resize='none'
                isReadOnly={isFormLoading}
                isError={meta.touched && meta.error}
                disabled={isDisabled || !hintInput.value}
                onEnter={onSubmit}
                enableVoiceInput
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <TooltipButton
        type='submit'
        styleColor={BUTTON_STYLES.SECONDARY}
        onClick={onSubmit}
        maxWidth={140}
        disabled={isDisabled || !hintInput.value}
        tooltip={isGenerating && t('messagesGenerating')}>
        <Icon icon={ICONS.ArrowUp} />
      </TooltipButton>
    </div>
  );
}

export default RepliesFormInner;
